document.addEventListener('DOMContentLoaded', () => {
  initImpactStatement()
}, false);

function initImpactStatement() {
  const $counts = document.querySelectorAll('[data-number]');
  if (!$counts.length) return;

  $counts.forEach(($count, i) => setUpCountAnimation($count, i))

  function setUpCountAnimation($el, index) {
    const elementIndex = index + 1;
    const { number } = $el.dataset;
    const formattedNumber = parseFloat(number.replace(/,/g, ''));
    const options = { enableScrollSpy: true, scrollSpyOnce: true };
    const counter = new countUp.CountUp(`count-target-${elementIndex}`, formattedNumber, options);

    if (!countUp.error) {
      counter.start();
    } else {
      console.error(counter.error);
    }
  }
}